import React from "react";
import { ORDER_TABS } from "../../../util/constants";

/**
 * AdditionalDetailsTab Component
 * Displays and manages the Additional Details tab content
 * Shows supplementary information that doesn't fit in Main Details
 */
const AdditionalDetailsTab = ({
  currentTabFields,
  isEditing,
  fieldValues,
  errorFieldArray,
  fieldValidationErrors,
  renderFieldInput,
  hasValidationError,
  getValidationErrorMessage,
}) => {
  if (currentTabFields.length === 0) {
    return (
      <div className="orders-empty-state">
        <p>No fields available for Additional Details.</p>
      </div>
    );
  }

  return (
    <div
      className={`details-grid ${!isEditing ? "view-mode" : ""}`}
      key={ORDER_TABS.ADDITIONAL}
    >
      {currentTabFields.map((field, index) => (
        <div
          key={`${ORDER_TABS.ADDITIONAL}-${field.field}-${index}`}
          className={`details-item ${
            errorFieldArray.includes(field.fieldStateKey) ? "has-error" : ""
          }`}
        >
          <div className="label">{field.labelToShowOnUI}</div>
          <div className="field-container">
            {renderFieldInput(field)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdditionalDetailsTab;
